export default __webpack_public_path__ + "static/media/Beard_4_C5.3b1d8e4b.svg";